import React, { Component } from 'react'
import { TableRow, TableCell } from '@material-ui/core'

// utils
import { onChangeEditHOF } from '../../utils/common'
import { hasAccess } from '../../utils/api'

import { EditableReactSelectCreatable } from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'
import { Appcues } from '../../utils/constants'

export default class WebHookItem extends Component {
  onChange = onChangeEditHOF(this.props.onChange)

  onSave = () => {
    Appcues.track('Webhook saved')
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  onChangewebHookUrls = (values) => {
    const webHookUrls = values && values.map((val) => val.value)

    this.props.onChange('webHookUrls', webHookUrls)
  }

  render() {
    const { data, editMode, label } = this.props

    return (
      <TableRow>
        <TableCell
          style={{
            width: 175,
          }}
        >
          {label}
        </TableCell>
        <TableCell className="cell-wrap-word">
          {/* <EditableTextField
                        valueToRender={data.url}
                        editMode={editMode}
                        value={data.url}
                        onChange={this.onChange('url')}
                        type="text"
                    /> */}
          <EditableReactSelectCreatable
            multi={true}
            value={
              (data.webHookUrls && data.webHookUrls.map((tag) => ({ label: tag, value: tag }))) ||
              []
            }
            onChange={this.onChangewebHookUrls}
            valueToRender={
              (data.webHookUrls && data.webHookUrls.length && data.webHookUrls.join(', ')) || ''
            }
            editMode={editMode}
            options={[]}
            clearable={false}
          />
        </TableCell>
        <TableCell className="cell-wrap-word">
          {hasAccess() ? (
            <div className="pull-right">
              <EditActionComponent
                onSave={this.onSave}
                onCancel={this.onCancel}
                onEdit={this.props.enableEdit}
                editMode={editMode}
              />
            </div>
          ) : null}
        </TableCell>
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/WebHooks/WebHookItem.js